import React from 'react';
import PropTypes from 'prop-types';
// mui
import { Box, Typography } from '@mui/material';
// utils
import { getStatusCellTextColor } from '../../../../utils/getClassName';
// style
import {
    tableCellInnerBoxStyle,
    tableStatusTextStyle
} from '../../../../styles/NewLeadTableRowStyle';

const formatStatus = (status) => {
    if (status === 'CLOSED') return 'Completed';
    if (status === 'FAILED_TO_ATTEND_CONSULTATION') return 'FTA';
    return status.charAt(0) + status.toLowerCase().replace(/_/g, ' ').slice(1);
};

const CustomStatusCell = ({ params, onChange }) => {
    if (!params?.row?.status) return null;
    const statusColor = getStatusCellTextColor(params?.row?.status);
    return (
        <Box onClick={() => onChange(params?.row)} sx={tableCellInnerBoxStyle}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                <Box
                    sx={{
                        width: 8,
                        height: 8,
                        borderRadius: '50%',
                        flexShrink: 0,
                        bgcolor: statusColor?.color || 'text.secondary',
                    }}
                />
                <Typography variant="05 Others/Label" sx={{ cursor: 'pointer', ...tableStatusTextStyle, ...statusColor }}>
                    {formatStatus(params?.row?.status)}
                </Typography>
            </Box>
        </Box>
    );
};

export default CustomStatusCell;

CustomStatusCell.propTypes = {
    params: PropTypes.any,
    onChange: PropTypes.func,
};
